var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 74,
    viewBox: "0 0 238 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.7355 30.667L58.1754 52.5818L45.675 20.8291H36.0279L23.6633 52.5139L15.1032 30.5991C12.7933 24.6964 7.08655 20.7612 0.700439 20.7612L18.9076 67.1011H28.4868L40.9873 35.3485L53.3519 67.1011H62.999L81.2062 20.7612C74.8201 20.7612 69.1133 24.6964 66.8035 30.5991L66.7355 30.667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.304 20.8286C98.122 20.8286 92.3474 23.2033 87.9314 27.6134C83.5155 32.0235 81.1377 37.7905 81.1377 43.9646C81.1377 50.1388 83.5155 56.0415 87.9314 60.3837C92.3474 64.726 98.122 67.1685 104.304 67.1685C108.109 67.1685 111.845 66.2865 115.106 64.5903C118.231 62.962 121.017 60.5194 123.123 57.6698L123.802 56.72L115.854 50.9529L115.174 51.9028C113.951 53.5311 112.389 54.9559 110.555 55.9058C108.652 56.9235 106.478 57.3984 104.304 57.3984C98.8014 57.3984 93.9099 53.9382 91.9397 48.9175H127.539V44.0325C127.539 37.8583 125.161 32.0913 120.745 27.6812C116.329 23.2711 110.555 20.8964 104.304 20.8964V20.8286ZM104.304 30.5987C109.875 30.5987 114.767 33.991 116.805 39.0118H91.9397C93.9099 33.991 98.8014 30.5987 104.304 30.5987Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M174.281 27.6138C169.933 23.2716 164.09 20.8291 157.84 20.8291C153.084 20.8291 148.397 22.3217 144.524 25.1035V10.1092C144.524 4.68135 140.108 0.339111 134.741 0.339111V67.169H157.908C164.158 67.169 170.001 64.7943 174.349 60.3842C178.697 55.9741 181.142 50.2071 181.142 43.9651C181.142 37.7231 178.697 32.0239 174.349 27.6138H174.281ZM171.02 46.6111C170.001 51.9033 165.789 56.1098 160.489 57.1275C159.606 57.3311 158.723 57.3989 157.908 57.3989H144.524V44.0329C144.524 43.4223 144.524 42.8795 144.66 42.2689C145.407 36.2983 150.231 31.4812 156.209 30.8027C165.245 29.6493 172.854 37.5874 171.088 46.679L171.02 46.6111Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M225.437 6.92065H237.598L188.548 73.8183H176.387L225.437 6.92065Z",
    fill: "url(#paint0_linear_70_2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.303 20.8286L202.95 33.991H190.721L193.303 20.8286Z",
    fill: "#5C53A3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M202.95 33.9915L196.836 42.3367L190.721 33.9915H202.95Z",
    fill: "#32C5F4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M181.074 20.8286H193.303L190.721 33.991L181.074 20.8286Z",
    fill: "#ED228B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M215.043 67.169L205.396 54.0066H217.624L215.043 67.169Z",
    fill: "#F57E20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M205.396 54.0061L211.51 45.6609L217.624 54.0061H205.396Z",
    fill: "#FECF0A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M227.272 67.169H215.043L217.625 54.0066L227.272 67.169Z",
    fill: "#EF3F23"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_70_2",
    x1: 227.476,
    y1: 4.95307,
    x2: 186.658,
    y2: 75.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D85C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#652C8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF0D7B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6a4b9fe8b471daa74274ae450fd5750b.svg";
export { ForwardRef as ReactComponent };